import {
  Checkbox,
  Divider,
  Drawer,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField
} from '@material-ui/core'
import { useStyles } from './rop-wl-filter.styles'
import React, { useState } from 'react'
import AsterTypography from 'asterX-UI/Typography/AsterTypography'
import { AutoCompleteField, FilterChip } from 'asterX-UI/Inputs'
import AsterButton from 'asterX-UI/Buttons/AsterButton'
import { KeyboardDatePicker } from '@material-ui/pickers'
import DateIcon from 'asterX-UI/Icons/DateIcon'
import MaskedTextInput from 'asterX-UI/Inputs/MackedTextInput'
import { creationTypes, dateTypes, paymentTypes, saleTypes } from './const'
import { useHomeStoreRop } from 'context/HomeStore/Rop'
import { AllStatusesDeal } from 'constants/deals'
import { CloseIcon, FilterIcon } from 'asterX-UI/Icons'

export const RopWLFilterMobile = () => {
  const classes = useStyles()

  const {
    homeStore: {
      branches,
      models,
      marks,
      managers,
      subdivisions,
      users,
      wlFilter
    },
    homeStoreFunc: {
      handleFilterChange,
      handleDateChange,
      handleClearFilter,
      getWlList
    }
  } = useHomeStoreRop()

  const [open, setOpen] = useState(false)

  const maxWidth = window.innerWidth - 16

  const handleSearch = () => {
    setOpen(false)
    getWlList()
  }

  const handleClear = () => {
    setOpen(false)
    handleClearFilter()
  }

  return (
    <>
      <Grid
        container
        alignItems="center"
        spacing="1"
        className={classes.mobileFilter}
        style={{ maxWidth }}
      >
        <Grid item>
          <IconButton onClick={() => setOpen(true)}>
            <FilterIcon />
          </IconButton>
        </Grid>
        <Grid item>
          <FilterChip
            type={'INPUT'}
            name="vin"
            label="VIN-код"
            textType={'text'}
            value={wlFilter?.car?.vin}
            onChange={e => handleFilterChange(e, 'car')}
          />
        </Grid>
        <Grid item>
          <FilterChip
            type={'INPUT'}
            label={'РЛ №'}
            name="id"
            value={wlFilter.id}
            onChange={handleFilterChange}
            textType={'number'}
          />
        </Grid>
        <Grid item>
          <FilterChip
            type={'AUTOCOMPLETE'}
            label="Филиал"
            name="branchCode"
            value={wlFilter.branchCode}
            valueKey={'code'}
            options={branches}
            onChange={handleFilterChange}
          />
        </Grid>
      </Grid>
      <Drawer anchor="right" open={open}>
        <Grid container spacing={4} style={{ padding: 10 }}>
          <Grid
            item
            container
            alignItems="center"
            justifyContent="space-between"
          >
            <Grid item>
              <AsterTypography variant="h6">Фильтр</AsterTypography>
            </Grid>
            <Grid item>
              <IconButton onClick={() => setOpen(false)}>
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
          <Grid item container spacing={3}>
            <Grid item xs={12} md={4} lg={3}>
              <TextField
                name="id"
                value={wlFilter.id}
                onChange={handleFilterChange}
                fullWidth
                label="Номер рабочего листа"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                name="eventId"
                value={wlFilter.eventId}
                onChange={handleFilterChange}
                fullWidth
                label="Номер задачи"
              />
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <AutoCompleteField
                name="statusCodes"
                value={wlFilter.statusCodes}
                multiple
                onChange={handleFilterChange}
                fullWidth
                label="Статус"
                keyArr="code"
                valueKey={'code'}
                options={AllStatusesDeal}
              />
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <AutoCompleteField
                value={wlFilter.managers}
                onChange={handleFilterChange}
                fullWidth
                label="Менеджер"
                labelKey="fullName"
                valueKey={'username'}
                multiple
                name="managers"
                options={managers}
              />
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <AutoCompleteField
                value={wlFilter.branchCode}
                onChange={handleFilterChange}
                fullWidth
                label="Филиал"
                name="branchCode"
                valueKey={'code'}
                options={branches}
              />
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <AutoCompleteField
                value={wlFilter.subdivision}
                onChange={handleFilterChange}
                fullWidth
                label="Звено"
                name="subdivision"
                valueKey={'id'}
                labelKey="rop"
                options={subdivisions}
              />
            </Grid>
          </Grid>

          <Grid item container alignItems="center" spacing={3}>
            <Grid item>
              <AsterTypography variant="h6">Рабочий лист</AsterTypography>
            </Grid>
            <Grid item style={{ flexGrow: 1 }}>
              <Divider />
            </Grid>
          </Grid>
          <Grid item container spacing={3}>
            <Grid item xs={6} md={4} lg={3}>
              <FormControl fullWidth>
                <InputLabel>Тип даты</InputLabel>
                <Select
                  name="dateType"
                  value={wlFilter.dateType}
                  onChange={handleFilterChange}
                >
                  {dateTypes.map(({ name, label }) => (
                    <MenuItem key={name} value={name}>
                      {label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6} md={4} lg={3}>
              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format="dd.MM.yyyy"
                label="Дата начала"
                name="dateFrom"
                value={wlFilter.dateFrom}
                onChange={val => handleDateChange(val, 'dateFrom')}
                keyboardIcon={<DateIcon />}
              />
            </Grid>
            <Grid item xs={6} md={4} lg={3}>
              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format="dd.MM.yyyy"
                label="Дата конца"
                name="dateTo"
                value={wlFilter.dateTo}
                onChange={val => handleDateChange(val, 'dateTo')}
                keyboardIcon={<DateIcon />}
              />
            </Grid>
            <Grid item xs={6} md={4} lg={3}>
              <FormControl fullWidth>
                <InputLabel>Формат оплаты</InputLabel>
                <Select
                  name="saleType"
                  value={wlFilter.saleType}
                  onChange={handleFilterChange}
                >
                  {saleTypes.map(e => (
                    <MenuItem key={e} value={e} name={e}>
                      {e}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6} md={4} lg={3}>
              <FormControl fullWidth>
                <InputLabel>Тип оплаты</InputLabel>
                <Select
                  name="paymentType"
                  value={wlFilter.paymentType}
                  onChange={handleFilterChange}
                >
                  {paymentTypes.map(e => (
                    <MenuItem key={e} value={e} name={e}>
                      {e}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6} md={4} lg={3}>
              <FormControl fullWidth>
                <InputLabel>Тип создания</InputLabel>
                <Select
                  name="creationType"
                  value={wlFilter.creationType}
                  onChange={handleFilterChange}
                >
                  {creationTypes.map(e => (
                    <MenuItem key={e} value={e.value} name={e.name}>
                      {e.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item container>
              <Grid item>
                <FormControlLabel
                  control={<Checkbox color="primary" />}
                  label="Подвод"
                />
              </Grid>
              <Grid item>
                <FormControlLabel
                  control={
                    <Checkbox
                      value={wlFilter.trade}
                      color="primary"
                      name="trade"
                      onChange={e => handleFilterChange(e)}
                    />
                  }
                  label="Trade In"
                />
              </Grid>
              <Grid item>
                <FormControlLabel
                  control={
                    <Checkbox
                      value={wlFilter.ropCheck}
                      color="primary"
                      onChange={e => handleFilterChange(e)}
                      name="ropCheck"
                    />
                  }
                  label="Проверено РОП"
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item container alignItems="center" spacing={3}>
            <Grid item>
              <AsterTypography variant="h6">Авто</AsterTypography>
            </Grid>
            <Grid item style={{ flexGrow: 1 }}>
              <Divider />
            </Grid>
          </Grid>
          <Grid item xs={12} md={4} lg={3}>
            <TextField
              name="vin"
              value={wlFilter.vin}
              onChange={handleFilterChange}
              fullWidth
              label="VIN-код"
            />
          </Grid>
          <Grid item xs={6} md={4} lg={3}>
            <AutoCompleteField
              name="marka"
              value={wlFilter.marka}
              onChange={handleFilterChange}
              fullWidth
              options={marks}
              label="Марка"
            />
          </Grid>
          <Grid item xs={6} md={4} lg={3}>
            <AutoCompleteField
              name="model"
              value={wlFilter.model}
              onChange={handleFilterChange}
              fullWidth
              label="Модель"
              options={models}
            />
          </Grid>
          <Grid item container alignItems="center" spacing={3}>
            <Grid item>
              <AsterTypography variant="h6">Клиент</AsterTypography>
            </Grid>
            <Grid item style={{ flexGrow: 1 }}>
              <Divider />
            </Grid>
          </Grid>
          <Grid item xs={12} md={4} lg={3}>
            <MaskedTextInput
              name="phoneNumber"
              value={wlFilter.phoneNumber}
              onChange={handleFilterChange}
              mask="+7 (999) 999-99-99"
              fullWidth
              label="Номер телефона"
            />
          </Grid>
          <Grid item xs={12} md={4} lg={3}>
            <TextField
              name="firstName"
              value={wlFilter.firstName}
              onChange={handleFilterChange}
              fullWidth
              label="Имя"
            />
          </Grid>
          <Grid item xs={12} md={4} lg={3}>
            <TextField
              name="lastName"
              value={wlFilter.lastName}
              onChange={handleFilterChange}
              fullWidth
              label="Фамилия"
            />
          </Grid>
          <Grid item xs={12} md={4} lg={3}>
            <MaskedTextInput
              name="iin"
              value={wlFilter.iin}
              onChange={handleFilterChange}
              mask="999999999999"
              fullWidth
              label="ИИН"
            />
          </Grid>
          <Grid item container spacing={3}>
            <Grid item xs={6}>
              <AsterButton
                style={{ fontSize: 14 }}
                fullWidth
                onClick={handleClear}
              >
                Сбросить
              </AsterButton>
            </Grid>
            <Grid item xs={6}>
              <AsterButton
                style={{ fontSize: 14 }}
                fullWidth
                color="primary"
                onClick={handleSearch}
              >
                Поиск
              </AsterButton>
            </Grid>
          </Grid>
        </Grid>
      </Drawer>
    </>
  )
}
